<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd" fxFlexFill>

    <div fxLayoutAlign="center center" class="text-center layout-padd">
        <p class="mat-subheading-1">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus, dolor. Vitae maxime neque voluptatibus eum voluptas repellendus possimus, obcaecati explicabo doloribus temporibus laboriosam sed dolores dolor dolore facilis aperiam. Temporibus?</p>
    </div>

    <form [formGroup]="productsSlotForm" #formDirective="ngForm" fxLayout="column" fxLayoutGap="10px" class="layout-padd">

        <mat-form-field>

            <mat-label>Jour</mat-label>

            <mat-select placeholder="Jour" formControlName="day" #selectDay>

                <mat-option *ngFor="let day of days" [value]="day.index" (click)="!day.closed ? onSelectDay(day) : ''" [disabled]="day.closed">

                    <div fxLayout="row" fxLayoutGap="10px">
                        <div fxLayoutAlign="center center">
                            <span>{{day.name}}</span>
                        </div>
                        <div fxLayoutAlign="center center" *ngIf="day.closed">
                            <span class="warn-ico">Fermé</span>
                        </div>
                    </div>

                </mat-option>

            </mat-select>

        </mat-form-field>

        <mat-form-field>

            <mat-label>{{'HOUR'|translate}}</mat-label>

            <mat-select placeholder="{{'HOUR'|translate}}" formControlName="hour" #selectHour>

                <mat-option *ngFor="let hour of hours" [value]="hour.value">
                    <span [class.secondary-ico]="hour.unavailable">{{hour.value}}</span>
                </mat-option>

            </mat-select>

        </mat-form-field>

        <button mat-raised-button color="primary" [disabled]="productsSlotForm.invalid" (click)="closeDial(true)">Charger
      les
      produits</button>

        <button mat-button [disabled]="productsSlotForm.invalid" (click)="closeDial(false)">Retour</button>

    </form>

    <app-popup-loader [flagLoading]="loader" [size]="30">
    </app-popup-loader>

</div>